<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

export default {
  name: 'App',
  data() {
    return {
      zhCN
    }
  },
  created() {
    this.loadJs();
  },
  methods: {
    loadJs() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'web3.min.js';
      document.body.appendChild(s);
    }
  }
}
</script>

<style>
#app {
  font-family:  -apple-system, BlinkMacSystemFont, segoe ui, Helvetica, Arial, sans-serif, apple color emoji, segoe ui emoji;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  height: 100%;
}

</style>
